<template>
    <!-- <BreadCrumb PageTitle="Liste des Décodeurs" /> -->
    <RegleDeConfidentialite />
</template>

<script lang="ts">
    import { defineComponent } from "vue";

    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import RegleDeConfidentialite from "../../components/Autres/RegleDeConfidentialite.vue";

    export default defineComponent({
        name: "RegleDeConfidentialitePage",
        components: {
            // BreadCrumb,
            RegleDeConfidentialite,
        },
    });
</script>